/**
 * Created by henian.xu on 2018/12/27.
 *
 */

export { default as payPopup } from './payPopup';
export { default as distributorPayPopup } from './distributorPayPopup';
export { default as prepaidPayPopup } from './prepaidPayPopup';
